import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Empresa } from 'src/app/_models/usuario/empresa';
import { EmpresaService } from 'src/app/_services/empresa.service';
import { EmpresaResponse } from 'src/app/_models/response/empresaResponse';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { DominioService } from 'src/app/_services/dominio.service';
import { Estado } from 'src/app/_models/dominio/estado';
import { Municipio } from 'src/app/_models/dominio/municipio';

@Component({
    templateUrl: 'empresa.component.html',
    styleUrls: ['../../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})

export class EmpresaComponent implements OnInit {

    empresaDialog: boolean;
    empresas: Empresa[];
    empresa: Empresa;
    selectedEmpresas: Empresa[];
    submitted: boolean;
    cols: any[];
    usuario: Usuario;
    perfil: Perfil;
    manterEmpresasLabel: string;
    header: any[];
    labelHeader: string;

 	estados: Estado[];
    estadoArr: any = [];
    estado: Estado;
    municipios: Municipio[];
    municipioArr: any = [];
    municipio: Municipio;
    filteredMunicipio: Municipio[];
    constructor(private empresaService: EmpresaService, private messageService: MessageService,
                private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
                private authenticationService: AuthenticationService, private bscobrancaTranslate: BscobrancaTranslate,
                private dominioService: DominioService) {
        this.manterEmpresasLabel = this.bscobrancaTranslate.getText('menu.manterEmpresa');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterEmpresasLabel, routerLink: ['/administracao/empresa/empresa'] }
        ]);
    }

    ngOnInit(): void {
        this.usuario = this.authenticationService.atualUserValue;
        this.perfil = this.authenticationService.atualUserPerfilValue;
		this.dominioService.getAllEstado().toPromise().then(data => this.estados = data);
        this.empresaService.getEmpresasPorUsuario(this.usuario).toPromise().then(data => this.empresas = data);
        this.cols = [
            { field: 'codAplicacao', header: 'Codigo Aplicacao' },
            { field: 'dscAplicacao', header: 'Descri��o Aplicacao' },
            { field: 'nmeAplicacao', header: 'Nome Aplicacao' },
            { field: 'dtaInclusao', header: 'Data Criacao' },
            { field: 'staAplicao', header: 'Situacao' }
        ];

        this.header = ['Nome', 'CNPJ', 'Endereco', 'E-mail', 'Telefone', 'Situacao'];
    }

	getMunicipioPorEstado() {
        this.dominioService.getAllMunicipioEstado(this.estado.uf).toPromise().then(data => this.municipios = data);
    }

    filterMunicipio(event: { query: any; }) {
            const filtered: any[] = [];
            const query = event.query;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.municipios.length; i++) {
                const status = this.municipios[i];
                if (status.nome.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                    filtered.push(status);
                }
            }
            this.filteredMunicipio = filtered;
        }
    openNew() {
        this.empresa = {};
		this.estado = {};
        this.municipio = {};
        this.submitted = false;
        this.empresaDialog = true;
    }

    deleteselectedEmpresas() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.empresas = this.empresas.filter(val => !this.selectedEmpresas.includes(val));
                this.selectedEmpresas = null;
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Empresa Excluida', life: 3000 });
            }
        });
    }

    editEmpresa(empresa: Empresa) {
        this.empresa = { ...empresa };
		if (!this.empresa.estado || this.empresa.estado === '') {
            this.estado = {};
        } else {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < this.estados.length; i++) {
                const status = this.estados[i];
                if (status.nome.toLowerCase().indexOf(this.empresa.estado.toLowerCase()) === 0) {
                    this.estado = status;
                }
            }
        }
        this.empresaDialog = true;
    }

    isCPF(documento: string): boolean{
        return documento == null ? true : documento.length < 12 ? true : false;
    }

    formatar_cnpj(v: string){
        v = v.replace(/[^0-9A-Za-z]/g, '').toUpperCase().substring(0, 14);   // CNPJ alfanumerico: mantem 0-9 e A-Z                          //Remove tudo o que n�o � d�gito
        v = v.replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2');            //Coloca ponto entre o segundo e o terceiro d�gitos
        v = v.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto d�gitos
        v = v.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2');           //Coloca uma barra entre o oitavo e o nono d�gitos
        v = v.replace(/([0-9A-Z]{4})([0-9A-Z])/, '$1-$2');              //Coloca um h�fen depois do bloco de quatro d�gitos
        return v;
    }

    formatar_cpf(v: string){
        v = v.replace(/\D/g, '');                    //Remove tudo o que n�o � d�gito
        v = v.replace(/(\d{3})(\d)/,"$1.$2");;       //Coloca um ponto entre o terceiro e o quarto d�gitos
        v = v.replace(/(\d{3})(\d)/,"$1.$2");       //Coloca um ponto entre o terceiro e o quarto d�gitos
                                                //de novo (para o segundo bloco de n�meros)
        v = v.replace(/(\d{3})(\d{1,2})$/,"$1-$2"); //Coloca um h�fen entre o terceiro e o quarto d�gitos
        return v;
    }

    formatarDocumento(documento: string) {
        if (documento && documento !== '') {
            if (this.isCPF(documento)) {
                return this.formatar_cpf(documento);
            } else {
                return this.formatar_cnpj(documento);
            }
        }
    }

    formata_telefone(v: string) {
        if (v && v !== '') {
            let r = v.replace(/\D/g, '');
            r = r.replace(/^0/, '');
            if (r.length > 10) {
                r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3');
            } else if (r.length > 5) {
                r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3');
            } else if (r.length > 2) {
                r = r.replace(/^(\d\d)(\d{0,5})/, '($1) $2');
            } else {
                r = r.replace(/^(\d*)/, '($1');
            }
            return r;
        }
        return '';
    }


    deleteEmpresa(empresa: Empresa) {
        let mensagem: string;
        let returnMessage: string;
        if (empresa.staEmpresa === 'Ativo') {
            mensagem = this.bscobrancaTranslate.getText('mensagens.empresa-001') + empresa.nmeEmpresa + '?';
            returnMessage = this.bscobrancaTranslate.getText('mensagens.empresa-002');
        } else {
            mensagem = this.bscobrancaTranslate.getText('mensagens.empresa-013') + empresa.nmeEmpresa + '?';
            returnMessage = this.bscobrancaTranslate.getText('mensagens.empresa-014');
        }

        this.confirmationService.confirm({
            message: mensagem,
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.empresaService.deletar(empresa).subscribe(
                    (empresaResponse: EmpresaResponse) => {
                        if (empresaResponse) {
                            if (empresaResponse.codigo === 0) {
                                this.empresa = {};
                                this.messageService.add({
                                    severity: 'success', summary: 'Successful', detail: returnMessage, life: 3000});
                                this.empresaService.getEmpresasPorUsuario(this.usuario).toPromise().then(data => this.empresas = data);
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: empresaResponse.mensagem,
                                life: 3000 });
                            }
                        } else {
                            this.messageService.add({
                                severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.empresa-003'),
                                life: 3000
                            });
                        }
                    });
            }
        });
    }

    validateEmpresa() {
        if (!this.empresa.nmeEmpresa) {
            return this.bscobrancaTranslate.getText('mensagens.empresa-004');
        }
        if (!this.empresa.dscEmail) {
            return this.bscobrancaTranslate.getText('mensagens.empresa-005');
        }
        if (!this.empresa.dscEndereco) {
            return this.bscobrancaTranslate.getText('mensagens.empresa-006');
        }
        if (!this.empresa.nroCNPJ) {
             return this.bscobrancaTranslate.getText('mensagens.empresa-007');
        }
        if (!this.empresa.nroTelefone) {
            return this.bscobrancaTranslate.getText('mensagens.empresa-008');
        }
		if (!this.empresa.estado) {
            return this.bscobrancaTranslate.getText('mensagens.empresa-015');
        }
        return '';
    }

    saveEmpresa() {
        this.submitted = true;
        const error = this.validateEmpresa();
        if (error !== '') {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
        } else {
            if (this.empresa.nmeEmpresa.trim()) {
                if (this.empresa.codEmpresa != null) {
                    this.empresaService.atualizar(this.empresa).subscribe(
                        (empresaResponse: EmpresaResponse) => {
                            if (empresaResponse) {
                                if (empresaResponse.codigo === 0) {
                                    this.empresas[this.findIndexById(empresaResponse.empresa.codEmpresa)] = this.empresa;
                                    this.messageService.add({ severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.empresa-009'), life: 3000 });
                                    this.empresaService.getEmpresasPorUsuario( this.usuario).toPromise().then(data => this.empresas = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: empresaResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.empresa-010'),
                                    life: 3000
                                });
                            }
                        });
                }
                else {
                    this.empresaService.inserir(this.empresa).subscribe(
                        (empresaResponse: EmpresaResponse) => {
                            if (empresaResponse) {
                                if (empresaResponse.codigo === 0) {
                                    this.empresas.push(empresaResponse.empresa);
                                    this.messageService.add({ severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.empresa-011'),  life: 3000 });
                                    this.empresaService.getEmpresasPorUsuario( this.usuario).toPromise().then(data => this.empresas = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error',
                                    detail: empresaResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.empresa-012'),
                                    life: 3000
                                });
                            }
                        });
                }

                this.empresas = [...this.empresas];
                this.empresaDialog = false;
                this.empresa = {};
            }
        }

    }

    hideDialog() {
        this.empresaDialog = false;
        this.submitted = false;
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.empresas.length; i++) {
            if (this.empresas[i].codEmpresa === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    downloadFile(filename= 'empresa') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.empresas.length; i++) {
             const emp = this.empresas[i];
             let line = (i + 1) + ';';
             line += emp.nmeEmpresa + ';';
             line += emp.nroCNPJ + ';';
             line += emp.dscEndereco + ';';
             line += emp.dscEmail + ';';
             line += emp.nroTelefone + ';';
             line += emp.staEmpresa + ';';
             str += line + '\r\n';
         }
         return str;
     }

}
